export default __webpack_public_path__ + "static/image03-874ce8c02a2deb66d0bdddc1012cdbc6.jpg";